import $ from "jquery";

/*$(window).scroll(function() {
   var hT = $('.summary-block').offset().top,
       hH = $('.summary-block').outerHeight(),
       wH = $(window).height(),
       wS = $(this).scrollTop();

       if (wS > (hT+hH-wH) && (hT > wS) && (wS+wH > hT+hH)){
            $('.summary-block').addClass('is-fixed');
        }
        else {
            $('.summary-block').removeClass('is-fixed');
        }
});*/
//set recap selection as sticky

$(function () {
	let $summaryBlock = $(".summary-block");
	let $trainingCourseContainer = $(".single-training-course__container");

	if ($summaryBlock.length && $trainingCourseContainer.length) {
		let is_sticky = false;
		let position_fixed = $summaryBlock.offset().top;
		let header_height = $(".site-header").height();
		let container_height = $(".entry-content").height();
		let page_header_height = $(".page-header").height();
		let full_height = container_height + page_header_height + header_height;
		let resume_height = $summaryBlock.outerHeight();

		$(document).scroll(function () {
			// console.log(full_height);
			if (window.scrollY + header_height + resume_height - full_height > 0) {
				$summaryBlock.removeClass("is-fixed");
				$summaryBlock.addClass("position-fixed-footer");
				$trainingCourseContainer.css("position", "static");
				// $(".entry-content").css("position", "relative");
				is_sticky = false;
			}
			if (!is_sticky && position_fixed <= window.scrollY + header_height && window.scrollY + header_height + resume_height - full_height < 0) {
				$summaryBlock.addClass("position-fixed");
				$summaryBlock.removeClass("position-fixed-footer");
				$trainingCourseContainer.css("position", "relative");
				//$(".entry-content").css("position", "static");
				is_sticky = true;
			} else if (is_sticky && position_fixed > window.scrollY + header_height) {
				$summaryBlock.removeClass("position-fixed");
				is_sticky = false;
			}
		});
	}

	$(".summary-block__title").click(function () {
		$(this).toggleClass("is-opened");
		$(".summary-block__content").toggleClass("is-opened");
	});
});
